import React, { useCallback, useEffect, useState, } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button, Checkbox, FormControlLabel, Grid } from "@mui/material";

/** COMPONENT */
import TableCustom from "../../../component/table/tableCustom";
import InputTextField from "../../../component/input/inputTextField";
import FilterSelect from "../../../component/select/filterSelect";
import HeaderCard from "../../../component/cardCustom/headerCard";
import TableRowCommon from "../../../component/table/TableRowCommon";
import ModalCustom from "../../../component/modalCustom/modalCustom";
import { swalActive, swalCustom, swalSuccess } from "../../../component/notification/swal";
import { useDispatch } from "react-redux";
import { showModal } from "../../../app/slice/modal.slice";
import { notiError, notiSuccess } from "../../../component/notification/notifications";
import { dateToView } from "../../../utils/date.utils";
import { Col, Row } from "react-bootstrap";
import moment from "moment";
import AutorenewIcon from '@mui/icons-material/Autorenew';
import { colors } from "../../../constants/colors";
import ModalStatus from "./ModalStatus";

/** STYLE */
import * as Style from "./userDefault.style"

/** API */
import UserApi, { updateStatusType } from "../../../api/auth/users.api";
import {
  isCreate,
  isDelete,
  isUpdate,
  isView,
} from "../../../utils/permission.utils";
import Loading from "../../../component/loading/loading";
import ModalAgent, { CustomerAgentItem } from "./modal/ModalAgent";
import { debouncedApiCall, escapeHtml } from "../../../utils/app.utils";
import CustomerAgentApi from "../../../api/customer-agent/customer-agent.api";
import { useHistory } from "react-router-dom";
import { routeName } from "../../../routes/routers-name";
import { useMenuPermission } from "../../inheritanceTransfer/useMenuPermission";
import { InheritanceCreatePrefill, InheritanceTransferLocationState } from "../../../constants/inheritanceTransfer";

const permissions = {
  isCreate: isCreate(),
  isDelete: isDelete(),
  isUpdate: isUpdate(),
  isView: isView(),
};
//จัดการข้อมูลลูกค้า
export default function User() {

  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const [firstname, setFirstname] = useState<string>('')
  const [lastname, setLastname] = useState<string>('')
  const [idCard, setIdCard] = useState<string>('')
  const [birthDay, setBirthDay] = useState<string>('')
  const [mobilePhone, setMobilePhone] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [taxId, setTaxId] = useState<string>('')
  const [houseNumber, setHouseNumber] = useState<string>('')
  const [moo, setMoo] = useState<string>('')
  const [village, setVillage] = useState<string>('')
  const [soi, setSoi] = useState<string>('')
  const [road, setRoad] = useState<string>('')
  const [zipCode, setZipCode] = useState<string>('')
  const [userData, setUserData] = useState<any[]>([])
  const [page, setPage] = useState<number>(1)
  const [pageLimit, setPageLimit] = useState<number>(5)
  const [rowCount, setRowCount] = useState<number>()
  const [sortBy, setSortBy] = useState<string>('modifiedDate')
  const [sortType, setSortType] = useState<string>('ASC')
  const [search, setSearch] = useState<string>('')
  const [status, setStatus] = useState<string>('ALL')
  /** กรองเฉพาะผู้ถือสิทธิที่มีผู้รับมรดกหมดอายุ (only_has_expired_heir=1) */
  const [onlyExpiredHeir, setOnlyExpiredHeir] = useState<boolean>(false)
  const [prefixNameTh, setPrefixNameTh] = useState<string>('')
  const [provinceNameTh, setProvinceNameTh] = useState<string>('')
  const [districtNameTh, setDistrictNameTh] = useState<string>('')
  const [subDistrictNameTh, setSubDistrictNameTh] = useState<string>('')
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [remark, setRemark] = useState<string>("");
  const [errorMessageRemark, setErrorMessageRemark] = useState<string>("");
  const [statusRemark, setStatusRemark] = useState<string>("");
  const [idUser, setIdUser] = useState<number>(Number);
  const [numRefresh, setNumRefresh] = useState<number>(0);

  // ผู้แทน
  const [showModalAgent, setShowModalAgent] = useState<boolean>(false);
  const [idCustomer, setIdCustomer] = useState<number | null>(null);
  const [idUserAgent, setIdUserAgent] = useState<number | null>(null);
  /** ชื่อผู้ถือสิทธิที่เปิด modal ผู้แทนอยู่ — ใช้เป็นค่าเริ่มต้น "ผู้โอน" ตอนพาไปทำรายการโอนมรดก */
  const [ownerNameAgent, setOwnerNameAgent] = useState<string>('');
  const handleCloseModalAgent = () => {
    setShowModalAgent(false);
    setIdCustomer(null);
    setIdUserAgent(null);
    setOwnerNameAgent('');
  }

  /** สิทธิ์ของเมนูโอนมรดก (ไม่ใช่เมนูหน้านี้) — ไม่มีสิทธิ์สร้างคำร้องก็ไม่ต้องชวนไปต่อ */
  const inheritancePermission = useMenuPermission();
  const history = useHistory();




  const loadData = useCallback(async () => {

    let condition: any = {}
    if (page) condition = { ...condition, page: page }
    if (pageLimit) condition = { ...condition, pageLimit: pageLimit }
    if (search) condition = { ...condition, search: search }
    if (sortBy) condition = { ...condition, sortBy: sortBy }
    if (sortType) condition = { ...condition, sortType: sortType }
    if (status) condition = { ...condition, status: status === 'ALL' ? '' : status }
    if (onlyExpiredHeir) condition = { ...condition, only_has_expired_heir: 1 }
    setIsLoading(true)
    const res = await UserApi.findAll(condition);
    if (res.status === 200) {
      setIsLoading(false);
      setRowCount(res.headers['total'])
      setUserData(res.data)
    } else {
      setIsLoading(false);
      setRowCount(0)
      setUserData([])
    }
  }, [page, pageLimit, search, sortBy, sortType, status, onlyExpiredHeir])


  useEffect(() => {
    loadData();
  }, [loadData])

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePageLimitChange = (newPageLimit: number) => {
    setPageLimit(newPageLimit);
  };

  const onRequestSort = (sortBy: string, sortType: string) => {
    setSortType(sortType)
    setSortBy(sortBy)
  }

  const headCells = [
    { id: "userId", disablePadding: false, label: "NO", },
    { id: "firstname", disablePadding: false, align: 'center', label: t("USER.HEADCELL.NAME"), sortable: true },
    { id: "idCard", disablePadding: false, align: 'center', label: t("USER.HEADCELL.IDCARD"), sortable: true },
    { id: "createDate", disablePadding: false, align: 'center', label: t("USER.HEADCELL.CREATEDATE"), sortable: true },
    { id: "status", disablePadding: false, align: 'center', label: t("สถานะการใช้งาน") },
    { id: "heirAlert", disablePadding: false, align: 'center', label: t("แจ้งเตือน") },
    { id: "remark", disablePadding: false, align: 'center', label: t("หมายเหตุ") },
    { id: "action", disablePadding: false, label: t("USER.HEADCELL.ACTION") }
  ];

  const onDelete = (data: any) => {
    const { userId, firstname, lastname } = data

    swalActive(
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('USER.ALERT.CONFIRM_DELETE')}</p>`,
      `<p class="mb-0 mx-auto" style="max-width: 325px">${t('USER.ALERT.CONFIRM_DELETE', {
        firstname: firstname, lastname: lastname ? ' ' + lastname + '' : ''
      })}</p>`,
      (res: any) => {
        if (res) {

          UserApi.delete(userId)
            .then((res) => {
              notiSuccess(t('USER.MESSAGE.SUCCESS.DELETE'), '', null, null)
              loadData()
            })
            .catch((e) => {
              notiError(t('USER.MESSAGE.ERROR'), '', null, null)
            })
        }
      }
    )
  }

  const renderData = (objData: any, no: number) => {
    no = page * pageLimit - pageLimit + no + 1
    const { userId, firstname, lastname, idCard, createDate, user } = objData;

    const objRenderData = {
      key: userId,
      id: userId,
      obj: objData,
      columns: [
        { option: "TEXT", align: "left", label: no },
        { option: "TEXT", align: "center", label: firstname + " " + (lastname || '') || "-" },
        { option: "TEXT", align: "center", label: idCard || "-" },
        { option: "TEXT", align: "center", label: dateToView(createDate) || "-" },
        {
          option: "TEXT", align: "center", label:
            <div
              className="p-1 text-white rounded-1 m-auto"
              style={{
                width: user?.status === 'ACTIVE' ? 100 : 120,
                backgroundColor: user?.status === 'ACTIVE' ? colors.green : colors.red,
              }}
            >
              {user?.status === "ACTIVE" ? 'เปิดใช้งาน' : 'ปิดการใช้งาน'}
            </div>
        },
        {
          option: "TEXT", align: "center", label: objData?.heir_expired_text ? (
            /** TableRowCommon บังคับ nowrap ที่ cell — ให้ข้อความตัดบรรทัดได้ในกล่องนี้แทน */
            <Box component="span" sx={{ display: 'inline-block', whiteSpace: 'normal', maxWidth: 110, fontSize: 14, color: colors.red, lineHeight: 1.4 }}>
              {objData.heir_expired_text}
            </Box>
          ) : ''
        },
        { option: "TEXT", align: "center", label: user?.remark || "-" },
        {
          option: 'ACTION',
          align: 'center',
          label: 'action',
          values: [
            // permissions?.isView.disabled
            { option: 'DOCUMENTDETAIL', label: t(`BUTTON.DOCUMENTDETAIL`), disabled: permissions?.isView.disabled },
            {
              option: 'CUSTOM_BUTTON', label: (
                <div onClick={() => {
                  setShowModalAgent(true);
                  setIdCustomer(objData?.customerId ?? null);
                  setIdUserAgent(objData?.userId ?? null);
                  setOwnerNameAgent(`${firstname || ''} ${lastname || ''}`.trim());
                }}>ผู้แทน</div>
              ), disabled: permissions?.isView.disabled
            },
            { option: 'DIVIDER', label: '', disabled: false },
            { option: 'DELETE', label: t(`BUTTON.DELETE`), disabled: permissions?.isDelete.disabled },
            {
              option: 'REASON', label:
                <Button
                  sx={{
                    fontSize: "16px",
                    fontWeight: "400",
                    backgroundColor: "inherit", '&:hover': {
                      backgroundColor: "inherit"
                    }
                  }}
                  startIcon={<AutorenewIcon />}
                >
                  {t(user?.status === 'ACTIVE' ? `ปิดการใช้งาน` : `เปิดการใช้งาน`)}
                </Button>, disabled: permissions?.isDelete.disabled
            },
          ]
        }
      ],

    };
    return (
      <TableRowCommon
        {...objRenderData}
        onreason={() => {
          if (user?.status === 'ACTIVE') {
            setIsShowModal(true)
            setIdUser(userId)
            onChangeStatus(user?.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE')
          } else {
            updateStatus(userId)
          }
        }}
        ondelete={() => onDelete(objRenderData.obj)}
        ondocumentdetail={() => onView(objRenderData.obj)}
      />
    )
  };

  const onChangeStatus = (status: 'ACTIVE' | 'INACTIVE') => {
    setStatusRemark(status)
  }
  const handleChangeRemark = (value: string) => {
    setRemark(value)
  }
  const handleSubmitStatus = async () => {
    if (!remark) {
      setErrorMessageRemark("ระบุเหตุผลในการปิดการใช้งาน")
      return;
    }
    let condition: updateStatusType = {
      remark: remark,
      status: statusRemark
    }
    setIsLoading(true)
    await UserApi.updateStatus(idUser, condition)
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false)
          notiSuccess('บันทึกข้อมูลเรียบร้อย')
          setIsShowModal(false)
          setErrorMessageRemark("")
          setRemark("")
        } else {
          setIsLoading(false)
          notiError('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
        }
      })
      .catch(() => {
        setIsLoading(false)
        notiError('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
      })
      .finally(() => loadData())
  }
  const updateStatus = async (userId: number) => {
    let condition: updateStatusType = {
      remark: '',
      status: 'ACTIVE'
    }
    setIsLoading(true)
    await UserApi.updateStatus(userId, condition)
      .then(res => {
        if (res.status === 200) {
          setIsLoading(false)
          notiSuccess('บันทึกข้อมูลเรียบร้อย')
          setIsShowModal(false)
          setErrorMessageRemark("")
          setRemark("")
        } else {
          notiError('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
        }
      })
      .catch(() => {
        setIsLoading(false)
        notiError('เกิดข้อผิดพลาดในการบันทึกข้อมูล')
      })
      .finally(() => loadData())
  }

  const onView = async (data: any) => {

    const { userId } = data
    const condition: any = {
      id: userId
    }

    await UserApi.getDetail(condition)
      .then((res) => {
        if (res.data?.customer_type === 'CORPORATION') {
          setPrefixNameTh(res.data?.customerHier[0]?.prefix?.prefixNameTh)
          setFirstname(res.data?.customerHier[0]?.firstname)
          setLastname(res.data?.customerHier[0]?.lastname)
          setIdCard(res.data?.customerHier[0]?.idCard)
          setBirthDay(res.data?.customerHier[0]?.birthDay)
          setMobilePhone(res.data?.customerHier[0]?.mobilePhone)
          // ของเก่าใช้  res.data.customerHier[0].email -> user อยากเปลี่ยนไปใช้ อีเมล์สำหรับเข้าสู่ระบบ (res.data.user.email)
          setEmail(res.data?.user?.email ?? "")
          setTaxId(res.data?.customerHier[0]?.taxId)
          setHouseNumber(res.data?.customerHier[0]?.houseNumber)
          setMoo(res.data?.customerHier[0].moo)
          setVillage(res.data?.customerHier[0]?.village)
          setSoi(res.data?.customerHier[0]?.soi)
          setRoad(res.data?.customerHier[0]?.road)
          setProvinceNameTh(res.data?.customerHier[0]?.province?.provinceNameTh || '');
          setDistrictNameTh(res.data?.customerHier[0]?.district?.districtNameTh || '');
          setSubDistrictNameTh(res.data?.customerHier[0]?.subDistrict?.subDistrictNameTh || '');
          setZipCode(res.data?.customerHier[0]?.zipCode)
        } else {
          setPrefixNameTh(res.data?.prefix?.prefixNameTh)
          setFirstname(res.data?.firstname)
          setLastname(res.data?.lastname)
          setIdCard(res.data?.idCard)
          setBirthDay(res.data?.birthDay)
          setMobilePhone(res.data?.mobilePhone)
          setEmail(res.data?.email)
          setTaxId(res.data?.taxId)
          setHouseNumber(res.data?.houseNumber)
          setMoo(res.data.moo)
          setVillage(res.data?.village)
          setSoi(res.data?.soi)
          setRoad(res.data?.road)
          setProvinceNameTh(res.data?.province?.provinceNameTh || '');
          setDistrictNameTh(res.data?.district?.districtNameTh || '');
          setSubDistrictNameTh(res.data?.subDistrict?.subDistrictNameTh || '');
          setZipCode(res.data?.zipCode)
        }

        dispatch(showModal())
      })
  }

  const handleDeleteAgent = async (id_customer_agent: number) => {
    swalActive("คุณต้องการลบตัวแทนใช่หรือไม่?", "ยืนยันการลบตัวแทน", async (status: boolean) => {
      if (status) {
        await CustomerAgentApi.delete(id_customer_agent).then((res) => {
          if (res.status < 300) {
            swalSuccess("ลบตัวแทนเรียบร้อย");
            setNumRefresh(prev => prev + 1)
          }
        }).catch((error) => {
          notiError(error?.response?.data?.error_description || "ลบตัวแทน ไม่สำเร็จ", '', null, null)
        })
      } else {
        return;
      }
    })
  }

  /** หลังรับเอกสารผู้รับมรดก: ถามว่าจะไปทำรายการโอนมรดกต่อเลยไหม (เปิด modal พร้อมผู้โอน/ผู้รับโอนไว้ให้) */
  const handleReceiveDocSuccess = (item: CustomerAgentItem) => {
    if (!inheritancePermission.isCreate || !idUserAgent) {
      swalSuccess("รับเอกสารเรียบร้อย");
      return;
    }
    const prefill: InheritanceCreatePrefill = {
      userId_owner: idUserAgent,
      customerId_owner: idCustomer,
      owner_fullname: ownerNameAgent,
      id_customer_agent: item.id_customer_agent,
    };
    swalCustom(
      "รับเอกสารเรียบร้อย",
      `ต้องการทำรายการโอนมรดกจาก <b>${escapeHtml(ownerNameAgent || '-')}</b><br/>ให้ <b>${escapeHtml(item.customer_fullname || '-')}</b> ต่อเลยหรือไม่?`,
      (status: boolean) => {
        if (!status) return;
        const state: InheritanceTransferLocationState = { createPrefill: prefill };
        history.push(routeName.inheritanceTransfer, state);
      },
      'success',
      {
        confirmButton: { confirmButtonText: "ไปทำรายการโอนมรดก" },
        cancelButton: { cancelButtonText: "ไว้ภายหลัง" },
      }
    );
  }


  return (
    <div className="w-100 position-relative">
      {isLoading && <Loading show />}
      {isShowModal &&
        <ModalStatus
          remark={remark}
          errorMessageRemark={errorMessageRemark}
          onChangeRemark={handleChangeRemark}
          clearErrorMessageRemark={() => setErrorMessageRemark("")}
          onClose={(status: boolean) => setIsShowModal(status)}
          onSubmit={() => handleSubmitStatus()}
          show={isShowModal}
        />}
      {showModalAgent && idCustomer !== null && (
        <ModalCustom
          title="ผู้ทำการแทน"
          isShowProps
          size="xl"
          closeButton
          onClose={handleCloseModalAgent}
          // MUI Autocomplete/Select render popper ผ่าน portal ออกนอก modal — ถ้า enforceFocus จะแย่ง focus กลับ
          enforceFocus={false}
          component={
            <ModalAgent
              id_customer={idCustomer}
              id_user={idUserAgent}
              onDelete={handleDeleteAgent}
              numRefresh={numRefresh}
              canAdd={!permissions?.isCreate?.disabled}
              canManageHeir={!permissions?.isUpdate?.disabled}
              onHeirChanged={loadData}
              onReceiveDocSuccess={handleReceiveDocSuccess}
            />
          }
        />
      )}
      <HeaderCard text={t("USER.TITLE")} />
      <Style.MainContainer>
        <Box>
          <Grid container spacing={2}>
            <Grid item lg={3} md={6} xs={12}>
              <InputTextField label={t("USER.INPUT.SEARCH")}
                // value={search}

                onchange={(event) => {
                  debouncedApiCall({ searchItem: event.target.value, setItem: setSearch });
                  // setSearch(event.target.value)
                  setPage(prev => prev !== 1 ? 1 : prev)
                }}
              />
            </Grid>
            <Grid item lg={3} md={6} xs={12} display="flex" alignItems="center">
              <FormControlLabel
                sx={{ m: 0, '.MuiFormControlLabel-label': { fontSize: 16 } }}
                control={
                  <Checkbox
                    checked={onlyExpiredHeir}
                    onChange={(event) => {
                      setOnlyExpiredHeir(event.target.checked)
                      setPage(prev => prev !== 1 ? 1 : prev)
                    }}
                    sx={{ '&.Mui-checked': { color: colors.themeSecondColor } }}
                  />
                }
                label="เฉพาะที่มีผู้รับมรดกหมดอายุ"
              />
            </Grid>

          </Grid>
        </Box>
        <Style.TableContainer>

          <TableCustom
            headCells={headCells}
            customScroll
            page={page}
            pageLimit={pageLimit}
            sortType={sortType}
            sortBy={sortBy}
            rowCount={rowCount}
            rowsData={userData.map((data: any, index: number) => {
              return renderData(data, index);
            })}
            onSort={onRequestSort}
            setPageLimit={handlePageLimitChange}
            setPage={handlePageChange}

          />
        </Style.TableContainer>

        <ModalCustom
          title={t("USER.DETAIL_TITLE")}
          size="xl"
          closeButton
          component={
            <div>
              <Row >
                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.NAME")}</Style.subMessage>
                  <Style.subMessage className="mr-2">{prefixNameTh || "-"}</Style.subMessage>
                  <Style.subMessage className="mr-2">{firstname + " " + lastname || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.IDCARD")}</Style.subMessage>
                  <Style.subMessage>{idCard || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.BIRTHDAY")}</Style.subMessage>
                  <Style.subMessage className="mr-2">{dateToView(birthDay)}</Style.subMessage>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.AGE")}</Style.subMessage>
                  {birthDay && <Style.subMessage className="mr-2">{moment().diff(birthDay, "years")}</Style.subMessage>}
                  <Style.subMessage>{t("USER.POPUP.YEARS")}</Style.subMessage>
                </Col>


              </Row>

              <Row className="mt-2">
                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.PHONE")}</Style.subMessage>
                  <Style.subMessage>{mobilePhone || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2" >{t("USER.POPUP.EMAIL")}</Style.subMessage>
                  <Style.subMessage>{email || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={4}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.TAXID")}</Style.subMessage>
                  <Style.subMessage>{taxId || "-"}</Style.subMessage>
                </Col>

              </Row>

              <Row className="mt-2" >
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.ADDRESS")}</Style.subMessage>
                  <Style.subMessage>{houseNumber || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.MOO")}</Style.subMessage>
                  <Style.subMessage>{moo || "-"}</Style.subMessage>
                </Col>

                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.VILLAGE")}</Style.subMessage>
                  <Style.subMessage>{village || "-"}</Style.subMessage>
                </Col>
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.SOI")}</Style.subMessage>
                  <Style.subMessage>{soi || "-"}</Style.subMessage>
                </Col>
              </Row>

              <Row className="mt-2">
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.ROAD")}</Style.subMessage>
                  <Style.subMessage>{road || "-"}</Style.subMessage>
                </Col>
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.PROVINCE")}</Style.subMessage>
                  <Style.subMessage>{provinceNameTh || "-"}</Style.subMessage>
                </Col>
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.DISTRICT")}</Style.subMessage>
                  <Style.subMessage>{districtNameTh || "-"}</Style.subMessage>
                </Col>
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.SUBDISTRICT")}</Style.subMessage>
                  <Style.subMessage>{subDistrictNameTh || "-"}</Style.subMessage>
                </Col>
              </Row>

              <Row className="mt-2">
                <Col className="d-flex flex-row" lg={3}>
                  <Style.subMessage className="mr-2">{t("USER.POPUP.POSTCODE")}</Style.subMessage>
                  <Style.subMessage>{zipCode || "-"}</Style.subMessage>
                </Col>
              </Row>
            </div>
          }

        />

      </Style.MainContainer>

    </div>
  );
}
